<template>
  <div>
    <el-table :data="data" style="width: 100%" :cell-style="cellStyle" :header-cell-style="rowClass">
      <el-table-column label="序号" prop="index" width="80"></el-table-column>
      <el-table-column prop="courseName" label="课程名称"></el-table-column>
      <el-table-column prop="expNum" label="实验数量"></el-table-column>
      <el-table-column prop="nickname" label="发布者"></el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="{ row }">
          <el-button size="mini" @click="handJump(row)">查看实验项目</el-button>
          <template v-if="row.createUser === userInfo.id">
            <el-button size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(row)" type="danger"
              >删除</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    handJump(row) {
      this.$emit('handJump', row)
    },
    handleEdit(row) {
      this.$emit('handleEdit', row)
    },
    handleDelete(row) {
      this.$emit('handleDelete', row)
    },
    cellStyle(){
        return "text-align:center"
    },
    rowClass(){
        return "text-align:center"
    }
  },
}
</script>
